// 美国时间：11月25日，PST时间 0:00
// 北京时间：11月25日，北京时间 15:00

const page_countdown = document.querySelector('.hasFlipdown .flipdown');
const countdown = page_countdown.getAttribute('data-time');
if (page_countdown && countdown) {
  
  const days = page_countdown.getAttribute('data-days') || 'Days';
  const hours = page_countdown.getAttribute('data-hours') || 'Hours';
  const minutes = page_countdown.getAttribute('data-minutes') || 'Minutes';
  const data = new Date(countdown);
  const daysFromNow = (data.getTime() / 1000);
  const hasFlipdownClassName =  document.getElementsByClassName("image-container")[0].classList;
  var flipdown = new FlipDown(daysFromNow, {
      headings: [days, hours, minutes], // 配置多语言
  })
    .start()
    .ifEnded(() => {
        // 倒计时结束后，移除DOM
        var flipdown = document.querySelector('#flipdown');
        var flipdownTit = document.querySelector('.flipdown-tit');
        if(flipdown) {
          flipdownTit.remove();
          flipdown.remove();
          hasFlipdownClassName.remove('hasFlipdown')
        }
    });

  }